// extracted by mini-css-extract-plugin
export default {"contactCard":"pLo954CXzZUcADVy3NY2","contactCardTitle":"NAN4HWTLjtcVW9YImlrc","contactCardContent":"NXQ4ZdHyYHEYM6Cjp9pd","contactCardAction":"goBSJ_csdmgPfjWFgG3H"};